
import CancelIcon from '@mui/icons-material/Cancel'
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import { CaseResponse } from '../../store/case/model';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import React from 'react';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './archiveCaseModal.module.css';
import { Modal, Button } from '@mui/material';
import { archiveCase, dearchiveCase } from 'src/store/case';

interface Props {
    readonly selectedCase?: CaseResponse;
    readonly showArchiveModal: boolean;
    readonly archiveCaseClose: () => void;
    readonly archiveCase: typeof archiveCase;
    readonly dearchiveCase: typeof dearchiveCase;
}


class ArchiveCaseModal extends React.Component<Props> {
  private localization: Ii18n;

  constructor(props: Props) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
        <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={this.props.showArchiveModal}
        onClose={() => this.props.archiveCaseClose()}
        >
        <div className={styles.archiveModal}>
          <div className={styles.rowCenter}>
            {this.props.selectedCase && this.props.selectedCase.archived
              ? this.localization.get('home.dearchiveCase')
              : this.localization.get('home.archiveCase')} : {this.props.selectedCase ? this.props.selectedCase.caseCode : ''}
          </div>
          <br />
          <div className={styles.rowCenter}>
            <Button
              variant='contained'
              className={styles.button}
              onClick={() => this.props.archiveCaseClose()} >
              {this.localization.get('shared.cancel')}
              <CancelIcon className={styles.rightIcon} />
            </Button>
            <Button
              variant='contained'
              color='primary'
              className={styles.button}
              onClick={() => {
                if (this.props.selectedCase) {
                  this.props.selectedCase.archived
                    ? this.props.dearchiveCase(this.props.selectedCase)
                    : this.props.archiveCase(this.props.selectedCase);
                }
              }} >
              {this.props.selectedCase && this.props.selectedCase.archived
                ? this.localization.get('home.dearchive')
                : this.localization.get('home.archive')}
              {this.props.selectedCase && this.props.selectedCase.archived
                ? <ArchiveIcon className={styles.rightIcon} />
                : <UnarchiveIcon className={styles.rightIcon} />}
            </Button>
          </div>
        </div>
        </Modal>
    );
  }
}

export { ArchiveCaseModal };
